import { useState } from "react";
import { NavLink } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { fetchLogout } from "actions/login";
import { TYPE_CITY, TYPE_NEIGHBORHOOD } from "actions/types";

// @mui material components
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Apartment from "@mui/icons-material/Apartment";

// Material Dashboard 3 PRO React components
import MDAvatar from "components/MDAvatar";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavItem from "examples/Sidenav/SidenavItem";
import SidenavList from "examples/Sidenav/SidenavList";
import { useMaterialUIController } from "context";

import { GiCampingTent } from "react-icons/gi";
import { GrOrganization } from "react-icons/gr";
import { MdLocationCity } from "react-icons/md";

import avatarH from "assets/img/default-avatar.png";
import avatarF from "assets/img/default-avatarF.png";
import avatar from "assets/img/default-avatarU.png";

const getDefaultAvatar = gender => {
	switch (gender) {
		case "H":
			return avatarH;
		case "F":
			return avatarF;
		default:
			return avatar;
	}
};

const CommunityIcon = ({ communitytype }) => {
	switch (communitytype) {
		case TYPE_CITY:
			return <MdLocationCity size={20} />;
		case TYPE_NEIGHBORHOOD:
			return <Apartment fontSize="small" />;
		default:
			return <GiCampingTent size={20} />;
	}
};

// Organization, community and connected user blocks displayed at the top of the sidenav
export default function SidenavHeader() {
	const dispatch = useDispatch();
	const [{ transparentSidenav, whiteSidenav, darkMode }] =
		useMaterialUIController();
	const [openUser, setOpenUser] = useState(false);
	const { user } = useSelector(state => state.profileReducer);
	const { community, organization } = useSelector(
		state => state.entitiesReducer
	);
	// Users signed in with Facebook have no local password to change
	const isStrategyLocal = localStorage.getItem("strategy") !== "facebook";

	return (
		<>
			<List>
				{organization?.name && (
					<NavLink to="/team/organization">
						<SidenavCollapse
							name={organization.name}
							icon={
								organization.logoUri ? (
									<MDAvatar
										src={organization.logoUri}
										alt={organization.name}
										size="xs"
									/>
								) : (
									<GrOrganization size={20} />
								)
							}
							noCollapse
						/>
					</NavLink>
				)}
				{community && community.communitytype !== "Organization" && (
					<NavLink to="/team/community">
						<SidenavCollapse
							name={community.name}
							icon={
								community.logoUri && !organization ? (
									<MDAvatar
										src={community.logoUri}
										alt={community.name}
										size="xs"
									/>
								) : (
									<CommunityIcon communitytype={community.communitytype} />
								)
							}
							noCollapse
						/>
					</NavLink>
				)}
				{user && (
					<SidenavCollapse
						name={`${user.firstname} ${user.lastname}`}
						icon={
							<MDAvatar
								src={user.photoUri || getDefaultAvatar(user.gender)}
								alt={`${user.firstname} ${user.lastname}`}
								size="xs"
							/>
						}
						open={openUser}
						onClick={() => setOpenUser(!openUser)}
					>
						<SidenavList>
							<NavLink to="/team/profile">
								<SidenavItem name="Profil" />
							</NavLink>
							{isStrategyLocal && (
								<NavLink to="/team/change-password">
									<SidenavItem name="Mot de passe" />
								</NavLink>
							)}
							<SidenavItem
								name="Se déconnecter"
								onClick={() => dispatch(fetchLogout())}
							/>
						</SidenavList>
					</SidenavCollapse>
				)}
			</List>
			<Divider
				light={
					(!darkMode && !whiteSidenav && !transparentSidenav) ||
					(darkMode && !transparentSidenav && whiteSidenav)
				}
			/>
		</>
	);
}
